<template>
  <div class="rt-content-wrapper">
    <div class="rt-content-main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtContent',
  computed: {
    hasAside () {
      return !!this.$slots.aside;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtContent.vue?7f545b88